module.exports = __webpack_public_path__ + "img/moroka-swallows.85732f75.png";